<template>
  <div class="ui bottom tab segment" data-tab="account">
    <form class="ui form" :class="{'loading': form.waiting}" v-if="model.user">
      <div class="field">
        <button type="button" class="ui positive button" @click="save()">保存する</button>
      </div>
      <div class="inline field">
        <label style="margin-left: 1em">ログインID</label>
        <div class="ui left icon input">
          <input type="text" :value="model.user.login_id" disabled>
          <i class="user icon"></i>
        </div>
      </div>
      <div class="inline field">
        <label>旧パスワード</label>
        <div class="ui left icon input">
          <input type="text" :value="model.user.plain_password" disabled>
          <i class="lock icon"></i>
        </div>
      </div>
      <div class="inline field" :class="{'error': form.hasError('password')}">
        <label>新パスワード</label>
        <div class="ui left icon input">
          <input type="text" v-model="form.model.password">
          <i class="lock icon"></i>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
            model: {},
            form: this.createForm(),
        };
    },
    methods: {
        initialize: function(model) {
            this.model = model;
        },
        save: function() {
            this.form.put(this.model.update_password_api_url, function() {
                window.location.reload();
            });
        }
    }
};
</script>
